import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "David Thompson",
        title: "Project Manager",
        biography: "David Thompson is an experienced Project Manager with a strong background in construction projects. He specializes in planning, coordinating, and overseeing installations and repairs, ensuring projects are completed on time and within budget. With a keen eye for detail and a commitment to quality, David works closely with teams and clients to deliver outstanding results. His leadership skills and industry expertise make him a valuable asset in managing complex projects efficiently.",
        contacts: {
            phone: "555-123-4567",
            email: "david.thompson@example.com",
            website: "www.davidthompsonconstruction.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Construction Project Coordinator",
            "Site Supervisor",
            "Budget & Resource Manager",
            "Safety Compliance Officer",
            "Client Relations Specialist"
        ],
        skills: [
            { id: 1, title: "Project Planning", progress: 98 },
            { id: 2, title: "Team Leadership", progress: 95 },
            { id: 3, title: "Budget Management", progress: 90 },
            { id: 4, title: "Risk Assessment", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Samantha Carter",
        title: "Structural Engineer",
        biography: "Samantha Carter is a skilled Structural Engineer known for her precision and innovative problem-solving. She has a proven track record in designing safe, resilient structures and collaborating with architects and contractors to ensure structural integrity across diverse projects. Samantha’s technical expertise and dedication to quality make her an invaluable contributor to any construction team.",
        contacts: {
            phone: "555-987-6543",
            email: "samantha.carter@example.com",
            website: "www.samanthacarterengineering.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Structural Design Specialist",
            "Load Analysis Expert",
            "Construction Consultant",
            "Code Compliance Advisor",
            "Foundation Design Engineer"
        ],
        skills: [
            { id: 1, title: "Structural Analysis", progress: 95 },
            { id: 2, title: "Design Optimization", progress: 92 },
            { id: 3, title: "AutoCAD & Revit", progress: 90 },
            { id: 4, title: "Safety Compliance", progress: 88 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "James Rodriguez",
        title: "Supervisor",
        biography: "James Rodriguez is a seasoned Supervisor with extensive experience in overseeing construction sites and coordinating teams. Known for his hands-on approach and problem-solving mindset, James ensures daily operations run smoothly and efficiently. His ability to manage crews, enforce safety standards, and maintain project timelines makes him a key figure in every successful build.",
        contacts: {
            phone: "555-456-7890",
            email: "james.rodriguez@example.com",
            website: "www.jamesbuildsupervision.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Site Supervisor",
            "Team Coordinator",
            "Workforce Manager",
            "Quality Assurance Lead",
            "Safety Compliance Officer"
        ],
        skills: [
            { id: 1, title: "Team Coordination", progress: 94 },
            { id: 2, title: "Time Management", progress: 91 },
            { id: 3, title: "Site Supervision", progress: 93 },
            { id: 4, title: "Safety Oversight", progress: 89 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emily Watson",
        title: "Architect",
        biography: "Emily Watson is a creative and detail-oriented Architect with a strong portfolio in residential and commercial design. With a passion for turning concepts into captivating spaces, she excels at blending aesthetics with functionality. Emily collaborates closely with clients and construction teams to ensure every design is both beautiful and buildable.",
        contacts: {
            phone: "555-987-6543",
            email: "emily.watson@example.com",
            website: "www.emilywatsondesigns.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Design Consultant",
            "Site Planner",
            "3D Modeling Specialist",
            "Client Liaison",
            "Sustainable Design Advocate"
        ],
        skills: [
            { id: 1, title: "Architectural Design", progress: 96 },
            { id: 2, title: "3D Visualization", progress: 93 },
            { id: 3, title: "Client Communication", progress: 90 },
            { id: 4, title: "Sustainable Design", progress: 88 }
        ]
    }
];

export default team;